<!--厕所详情-->
<template>
  <div class="page-content">
    <loading v-if="loading"></loading>
    <div v-show="!loading">
      <div class="wcde-content">
        <!-- <van-swipe :loop="false" @change="onChange" :height="height" :initial-swipe="current" v-if="wc.iconPath && wc.iconPath.length > 0">
        <van-swipe-item v-for="(v, i) in wc.iconPath" :key="i">
          <van-image :src="v"></van-image>
        </van-swipe-item>
      </van-swipe> -->

        <img :src="coverImg?coverImg:noListIcon" />

        <div class="wcde-title">{{ wc.toiletName }}</div>
        <div class="wcde-point">卫生{{ (point.healthMark || 0) | parseInt }}分 | 环境{{(point.environmentMark || 0) | parseInt}}分 | 气味{{ (point.smellMark || 0) | parseInt }}分</div>
        <div class="wcde-tags">
          <!-- <div class='tags-item' v-if='i === 0'>离我最近</div> -->
          <div class="tags-item" v-if="wc.hasThird">母婴室</div>
          <div class="tags-item" v-if="wc.hasDisabled">无障碍卫生间</div>
          <div class="tags-item" v-if="wc.smart == 1">智慧厕所</div>
          <div class="tags-item" v-if="showDistanceForMe && isShowDistance">离我最近</div>

        </div>
        <div class="wcde-line"></div>
        <div class="wcde-msg" v-if="wc.smart == 1 && (wc.maleCount > 0 || wc.femaleCount > 0 || wc.disabledCount > 0 || wc.thirdCount > 0)">
          <div class="msg-item">
            <div><img class="msg_icon" src="../../assets/img/man_icon.png" alt="">男厕：</div>
            <div>总坑位{{ wc.maleCount || 0 }}个，空位{{wc.maleSurplusCount || 0}}个</div>
          </div>
          <div class="msg-item">
            <div><img class="msg_icon" src="../../assets/img/felman_icon.png" alt="">女厕：</div>
            <div>总坑位{{ wc.femaleCount || 0 }}个，空位{{wc.femaleSurplusCount || 0}}个</div>
          </div>
          <div class="msg-item">
            <div><img class="msg_icon" src="../../assets/img/disable_icon.png" alt="">残疾人厕：</div>
            <div>总坑位{{ wc.disabledCount || 0 }}个，空位{{wc.disabledSurplusCount || 0}}个</div>
          </div>
          <div class="msg-item">
            <div><img class="msg_icon" src="../../assets/img/third_icon.png" alt="">第三人厕：</div>
            <div>总坑位{{ wc.thirdCount || 0 }}个，空位{{wc.thirdSurplusCount || 0}}个</div>
          </div>
        </div>
        <div class="wcde-map">
          <div id="map" style="width:100%;height:100%;border-radius:2px;"></div>
        </div>
      </div>
      <div class="wcde-bottom">
        <div class="wcde_box">
          <div class="wcde-nav" @click="toUrl">
            <img :src="findwc_pinlun" alt="" srcset="" />
            评价
          </div>
          <div class="wcde-nav" @click="toWxT">
            <img :src="findwc_tousu" alt="" srcset="" />
            投诉
          </div>
        </div>
        <div class="wcde-btn" @click="goTo">导航去这里</div>
      </div>
    </div>

  </div>
</template>
<script>
// import { mapState, mapActions } from 'vuex'
import Loading from '@/components/loading';
import qs from 'qs';
import { Dialog } from 'vant';
const wcIcon = require('../../assets/iconImage/wc@2x.png');
const QQMap = window.qq.maps;
export default {
  data() {
    return {
      current: 1,
      height: 200,
      tags: [{ tag: '智慧厕所' }, { tag: '无障碍卫生间' }, { tag: '母婴室' }],
      findwc_pinlun: require('../../assets/img/coment_icon.png'),
      findwc_tousu: require('../../assets/img/plant_icon.png'),
      noListIcon: require('../../assets/iconImage/collection_list.png'),
      wc: {},
      latitude: '',
      longitude: '',
      location: '成都市',
      address: '',
      userIsComplaint: '',
      userIsComment: '',
      point: {},
      lat: '',
      lng: '',
      // url: 'https://cos-web.wiiqq.com/#/wcEvaluation?wc_id=' + this.$route.query.wc_id, // 微信授权地址
      state: 'abc123', // 微信授权状态码
      user: {
        uid: '',
        userName: '', // 用户名
      },
      userImg: '',
      mobile: '',
      loginShow: true,
      loading: true,
      coverImg: '',
      showDistanceForMe: false,
      isShowDistance: false
    };
  },
  components: {
    Loading,
  },
  mounted() {
    this.isShowDistance = Boolean(sessionStorage.getItem('isShowDistance'));
    this.showDistanceForMe = this.$route.query.showDistanceForMe == 'true';
    if (!this.$cookie.get('w_uid')) {
      this.wxAuth();
    }
    this.initData();
  },
  methods: {

    /**
     * 初始化分享事件
     */
    shareInit() {
      wx.ready(() => {
        // eslint-disable-next-line
        //需在用户可能点击分享按钮前就先调用
        wx.updateAppMessageShareData({
          title: this.detailData.toiletName, // 分享标题
          desc: this.detailData.describe, // 分享描述
          link: window.location.href, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
          imgUrl: this.detailData.image, // 分享图标
          success: function () {
            // 分享成功
          },
        });
        wx.updateTimelineShareData({
          title: this.detailData.toiletName, // 分享标题
          link: window.location.href, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
          imgUrl: this.detailData.image,
          success: function () {
            // 分享成功
          },
        });
      });
      wx.error(function (res) { });
    },
    /**
     * 去评价
     */
    toUrl() {
      if (this.$cookie.get('w_open_id') == '' || this.$cookie.get('w_open_id') == null) {
        this.$toast('请授权');
        this.wxAuth();
      } else {
        this.getUserInfo().then(res => {
          if (res === '手机号存在') {  // 跳转评价页面
            this.$router.push({
              path: '/wcEvaluation',
              query: {
                wc_id: this.$route.query.wc_id,
              },
            });
          }
        }).catch(e => {
          if (e === '未绑定手机号码') {  // 未绑定
            this.$toast('请绑定手机号码');
            this.$router.push({ path: '/bindingPhone' });
          }else{
            this.$toast('登录状态过期，请重新登陆');
            this.wxAuth();
          }

        })
      }
    },

    /**
     * 去投诉
     */
    toWxT() {
      if (
        this.$cookie.get('w_open_id') == '' ||
        this.$cookie.get('w_open_id') == null
      ) {
        this.$toast('请授权');
        this.wxAuth();
      } else {
        this.getUserInfo().then(res => {
          if (res === '手机号存在') {  // 跳转评价页面
            this.$router.push({
              path: '/complainSubmitWc',
              query: {
                toiletNum:this.wc.toiletNum,
                toiletName:this.wc.toiletName,
                wcName: this.wc.toiletName,
                wcId: this.$route.query.wc_id,
              },
            });
          }
        }).catch(e => {
          if (e === '未绑定手机号码') {  // 未绑定
            this.$toast('请绑定手机号码');
            this.$router.push({ path: '/bindingPhone' });
          }else{
            this.$toast('登录状态过期，请重新登陆');
            this.wxAuth();
          }

        })
      }
    },

    getUserInfo() {
      return new Promise((resolve, reject) => {
        let open_id = this.$cookie.get('w_open_id');
        let skey = this.$cookie.get('w_skey');
        let uid = this.$cookie.get('w_uid');
        this.$request
          .post(
            `/appserver/v1/user/get_auth_data?open_id=${open_id}&skey=${skey}&uid=${uid}`
          )
          .then((data) => {
            if (data.data.ret === 0) {
              // this.phone = data.data.data.mobile;
              if (data.data.data.mobile) {
                resolve('手机号存在');
              } else {
                reject('未绑定手机号码');
              }
            } else {
              // 把用户信息存到localStorage
              reject(data);
            }
          });
      })

    },

    initData() {
      this.loading = true;
      this.$request({
        url: `/appserver/v1/toilet/detail?${qs.stringify({
          toiletId: this.$route.query.wc_id,
          userId: localStorage.getItem('uid') || '',
          // wisdomNum:
          //   this.$route.query.toiletName +
          //   '(' +
          //   this.$route.query.toiletNum +
          //   ')',
        })}`,
      }).then((res) => {
        // console.log(res)
        if (res.status === 200) {
          this.wc = res.data ? res.data.data : {};
          this.loading = false;
          this.latitude = this.wc.latitude;
          this.longitude = this.wc.longitude;
          this.address = this.wc.address;
          this.userIsComment = this.wc.userIsComment;
          this.userIsComplaint = this.wc.userIsComplaint;
          this.coverImg = this.wc.image;
          this.detailData = this.wc;
          setTimeout(() => {
            this.shareInit();
          }, 300)
          var myLatlng = new QQMap.LatLng(
            Number(this.wc.latitude),
            Number(this.wc.longitude)
          );
          var marker = new QQMap.Marker({
            position: myLatlng,
            map: this.map,
            icon: this.icon,
          });
          marker.setVisible(true);
        }
      });
      this.$request({
        url: `/appserver/v1/toilet/queryToiletAvgComment?${qs.stringify({
          toiletId: this.$route.query.wc_id,
        })}`,
      }).then((res) => {
        // console.log(res)
        if (res.status === 200) {
          this.point = res.data ? res.data.data : {};
        }
      });
      this.initMap();
    },
    initMap() {
      /* eslint-disable */
      // 设置地图中心点
      var myLatlng = new QQMap.LatLng(
        this.$route.query.latitude || 30.7288,
        this.$route.query.longitude || 103.97373
      );
      //厕所位置
      // var wcLatlng = new QQMap.LatLng(this.$route.query.latitude, this.$route.query.longitude);
      // 定义工厂模式函数
      var myOptions = {
        zoom: 11, // 设置地图缩放级别
        center: myLatlng, // 设置中心点样式
        zoomControl: false,
        disableDefaultUI: true,
        mapTypeId: qq.maps.MapTypeId.ROADMAP, // 设置地图样式详情参见MapType
      };
      // 获取dom元素添加地图信息
      this.map = new QQMap.Map(document.getElementById('map'), myOptions);
      var marker = new QQMap.Marker({
        // position: myLatlng,
        map: this.map,
        // icon: wcIcon
      });
      marker.setVisible(true);
      var size = new QQMap.Size(28, 30);
      var origin = new QQMap.Point(0, 0);
      var anchor = new QQMap.Point(14, 30);
      var scaleSize = new QQMap.Size(28, 30);
      this.icon = new QQMap.MarkerImage(
        wcIcon,
        size,
        origin,
        anchor,
        scaleSize
      );
    },
    onChange() { },
    goTo() {
      this.wc.address = this.wc.address ? this.wc.address : ' ';
      this.openLocation(this.wc.latitude, this.wc.longitude, this.wc.toiletName, this.wc.address);
    },
  },
  filters: {
    parseInt(num) {
      return parseInt(num).toFixed(1);
    },
  },
};
</script>
<style lang="scss">
.page-content {
  .wcde-content {
    width: 100%;
    height: calc(100% - 80px);
    padding: 10px 20px;
    box-sizing: border-box;
    overflow-y: auto;
    padding-bottom: 80px;
    img {
      width: 100%;
      height: 210px;
      border-radius: 2px;
    }
    .wcde-title {
      padding: 16px 0px;
      font-size: 16px;
      font-family: PingFang-SC-Bold, PingFang-SC;
      font-weight: bold;
      color: #262626;
      line-height: 17px;
    }
    .wcde-point {
      font-size: 12px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #787878;
      line-height: 15px;
    }
    .wcde-tags {
      display: flex;
      flex-wrap: wrap;
      padding: 12px 0px 19px 0px;
      .tags-item {
        // height: 35px;
        background: rgba(110, 90, 219, 0.15);
        border-radius: 2px;
        padding: 3px 5px;
        text-align: center;
        // line-height: 35px;
        box-sizing: border-box;
        font-size: 11px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #6145f7;
        margin-right: 10px;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
      }
    }
    .wcde-line {
      width: 100%;
      height: 1px;
      background: #e8e8e8;
    }
    .wcde-msg {
      box-sizing: border-box;
      padding: 10px 0;
      .msg-item {
        div {
          display: flex;
          align-items: center;
        }
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: rgba(85, 89, 89, 1);
        line-height: 14px;
        &:not(:last-child) {
          margin-bottom: 12px;
        }
        display: flex;
        align-items: center;
        justify-content: space-between;
        .msg_icon {
          width: 20px;
          height: 20px;
          margin-right: 5px;
        }
      }
    }
    .wcde-map {
      width: 100%;
      height: 180px;
      border-radius: 2px;
    }
  }
  .wcde-bottom {
    width: 100%;
    height: 80px;
    box-sizing: border-box;
    padding: 20px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    box-shadow: 0px -2px 3px 0px rgba(0, 0, 0, 0.1);
    position: fixed;
    bottom: 0;
    left: 0;
    background: white;
    .wcde_box {
      display: flex;
      align-items: center;
    }
    .wcde-nav {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      img {
        width: 18px;
        height: 18px;
        margin-bottom: 3px;
      }
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: rgba(85, 89, 89, 1);
      line-height: 16px;
      margin-right: 20px;
      display: flex;
      align-items: center;
    }
    .wcde-btn {
      // flex: 1;
      font-size: 15px;
      font-family: PingFangSC-Semibold, PingFang SC;
      font-weight: 600;
      color: rgba(255, 255, 255, 1);
      line-height: 40px;
      text-align: center;
      background: #2eba73;
      border-radius: 18px;
      padding: 0px 20px;
    }
  }
}
</style>
